const currencyFormatter = new Intl.NumberFormat('en-US', {
    // style: 'currency',
    // currency: 'EUR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
});

export const FinancialHeader = [
    { field: 'id', headerName: '#', width: 58, headerClassName: 'super-app-theme--header', groupable: false, aggregable: true },
    // { field: 'accID', headerName: 'ID e Llogarisë', width: 120, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
    { field: 'actionType', headerName: 'Tipi', width: 90, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
    { field: 'accName', headerName: 'Emri Llogarisë', width: 300, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
    { field: 'idNumber', headerName: 'Numri Identifikues', width: 150, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
    { field: 'comment', headerName: 'Koment', width: 150, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
    { field: 'date', headerName: 'Data', width: 166, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
    {
        field: 'debit', headerName: 'Debit', type: 'string', width: 120, editable: false, headerClassName: 'super-app-theme--header', groupable: true,
        valueFormatter: (value) => {
            if (!value) {
                return value;
            }
            return currencyFormatter.format(value);
        },
    },
    {
        field: 'credit', headerName: 'Kredit', type: 'string', width: 120, editable: false, headerClassName: 'super-app-theme--header', groupable: true,
        valueFormatter: (value) => {
            if (!value) {
                return value;
            }
            return currencyFormatter.format(value);
        },
    },
    {
        field: 'progressive', headerName: 'Progresive', type: 'string', width: 120, editable: false, headerClassName: 'super-app-theme--header', groupable: true,
        valueFormatter: (value) => {
            if (!value) {
                return value;
            }
            return currencyFormatter.format(value);
        },
    },
]

export const MaterialSintetikHeaders = [
    { field: 'id', headerName: '#', width: 60, headerClassName: 'super-app-theme--header', groupable: false, aggregable: true },
    // { field: 'accID', headerName: 'ID e Llogarisë', width: 120, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
    { field: 'Barcode', headerName: 'Barkodi', width: 160, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
    { field: 'ArticleName', headerName: 'Artikulli', width: 300, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
    { field: 'totalTransaction', headerName: 'Numri Transaksioneve', width: 146, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
    {
        field: 'TotalQtyOutput', headerName: 'Sasia', type: 'string', width: 170, editable: false, headerClassName: 'super-app-theme--header', groupable: true,
        valueFormatter: (value) => {
            if (!value) {
                return value;
            }
            return currencyFormatter.format(value);
        },
    },
    {
        field: 'AvgPriceWithoutVAT', headerName: 'Cmimi mesatar', type: 'string', width: 170, editable: false, headerClassName: 'super-app-theme--header', groupable: true,
        valueFormatter: (value) => {
            if (!value) {
                return value;
            }
            return currencyFormatter.format(value);
        },
    },
    {
        field: 'TotalAmount', headerName: 'Vlera', type: 'string', width: 170, editable: false, headerClassName: 'super-app-theme--header', groupable: true,
        valueFormatter: (value) => {
            if (!value) {
                return value;
            }
            return currencyFormatter.format(value);
        },
    },
]

export const MaterialAnalitikHeaders = [
    { field: 'id', headerName: '#', width: 60, headerClassName: 'super-app-theme--header', groupable: false, aggregable: true },
    // { field: 'accID', headerName: 'ID e Llogarisë', width: 120, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
    { field: 'ActionType', headerName: 'ActionType', width: 85, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
    { field: 'Barcode', headerName: 'Barcode', width: 200, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
    { field: 'ArticleName', headerName: 'ArticleName', width: 350, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
    { field: 'date', headerName: 'Data', width: 100, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
    {
        field: 'QtyOutput', headerName: 'Sasia', type: 'string', width: 160, editable: false, headerClassName: 'super-app-theme--header', groupable: true,
        valueFormatter: (value) => {
            if (!value) {
                return value;
            }
            return currencyFormatter.format(value);
        },
    },
    {
        field: 'PriceWithVAT', headerName: 'Cmimi me TVSH', type: 'string', width: 160, editable: false, headerClassName: 'super-app-theme--header', groupable: true,
        valueFormatter: (value) => {
            if (!value) {
                return value;
            }
            return currencyFormatter.format(value);
        },
    },
    {
        field: 'TotalAmount', headerName: 'Vlera', type: 'string', width: 160, editable: false, headerClassName: 'super-app-theme--header', groupable: true,
        valueFormatter: (value) => {
            if (!value) {
                return value;
            }
            return currencyFormatter.format(value);
        },
    },
]



